<ion-header [translucent]="true">
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title>Osztályfőnök</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true" class="of-content">
  <ion-grid class="of-page">
    <!--  OSZTÁLY ÉS NÉZET. Az osztály-választó mindhárom nézetre szól, ezért került a kártyák
          fölé; a nézetek: a hiányzások (az eddigi képernyő), az osztály jegyei és a tanórai
          feljegyzések („ikszes órák"). -->
    <ion-row *ngIf="!loadingOsztalyok && osztalyok.length">
      <ion-col size="12">
        <div class="of-fejsav">
          <ion-item lines="none" class="of-select">
            <ion-label position="stacked">Osztály</ion-label>
            <ion-select [(ngModel)]="kivOsztalyId" (ionChange)="onOsztalyChange()" interface="popover">
              <ion-select-option *ngFor="let o of osztalyok" [value]="o.osztaly_id">
                {{ o.osztaly_nev }}<span *ngIf="(o.of_nev || o.of_username) && admin"> ({{ o.of_nev || o.of_username }})</span><span
                  *ngIf="o.szerep === 'helyettes'"> – helyettesként</span>
              </ion-select-option>
            </ion-select>
          </ion-item>
          <ion-segment class="of-nezetvalto" [scrollable]="true" [value]="nezet"
                       (ionChange)="nezetValt($event.detail.value)">
            <ion-segment-button value="hianyzas">
              <ion-icon name="calendar-clear-outline"></ion-icon>
              <ion-label>Hiányzások</ion-label>
            </ion-segment-button>
            <ion-segment-button value="elbiralas" *ngIf="varolista.length">
              <ion-icon name="alert-circle-outline"></ion-icon>
              <ion-label>Elbírálásra vár ({{ varolista.length }})</ion-label>
            </ion-segment-button>
            <ion-segment-button value="jegyek">
              <ion-icon name="school-outline"></ion-icon>
              <ion-label>Jegyek</ion-label>
            </ion-segment-button>
            <ion-segment-button value="ikszek">
              <ion-icon name="close-circle-outline"></ion-icon>
              <ion-label>Tanórai feljegyzések</ion-label>
            </ion-segment-button>
            <ion-segment-button value="szakvelemeny">
              <ion-icon name="medkit-outline"></ion-icon>
              <ion-label>SNI / BTMN</ion-label>
            </ion-segment-button>
            <!-- Minősíthetőség a mulasztás miatt (51. § (7)–(8)) – of-minosithetoseg komponens. -->
            <ion-segment-button value="minosithetoseg">
              <ion-icon name="ribbon-outline"></ion-icon>
              <ion-label>Minősíthetőség</ion-label>
            </ion-segment-button>
            <ion-segment-button value="lemorzsolodas">
              <ion-icon name="trending-down-outline"></ion-icon>
              <ion-label>Lemorzsolódás</ion-label>
            </ion-segment-button>
            <!-- Késve rögzített mulasztások (Nkt. 54. § (1)) – of-kesve-mulasztas komponens. -->
            <ion-segment-button value="kesve">
              <ion-icon name="time-outline"></ion-icon>
              <ion-label>Késve rögzített mulasztások</ion-label>
            </ion-segment-button>
          </ion-segment>
        </div>
      </ion-col>
    </ion-row>

    <!--  MINŐSÍTHETŐSÉG A MULASZTÁS MIATT (20/2012. EMMI r. 51. § (7)–(8)): évközi számláló
          tanulónként és tantárgyanként, osztályozó vizsga jelölése – önálló komponens
          (of-minosithetoseg/), a számítás backend/mulasztas-arany.js. -->
    <ion-row *ngIf="nezet === 'minosithetoseg' && !loadingOsztalyok && osztalyok.length">
      <ion-col size="12">
        <app-of-minosithetoseg [intezmeny]="intezmeny" [osztaly]="kivOsztalyId" [tanev]="tanev"
                               [username]="username"></app-of-minosithetoseg>
      </ion-col>
    </ion-row>

    <!--  KÉSVE RÖGZÍTETT MULASZTÁSOK (Nkt. 54. § (1)): a hiányzós órák, amelyeket az óra napjánál
          később könyveltek, tanáronkénti összesítővel – önálló komponens (of-kesve-mulasztas/), a
          számítás backend/mulasztas-ertesites.js › kesveKimutatas. Az admin az egész intézményre is lekérheti. -->
    <ion-row *ngIf="nezet === 'kesve' && !loadingOsztalyok && osztalyok.length">
      <ion-col size="12">
        <app-of-kesve-mulasztas [intezmeny]="intezmeny" [osztaly]="kivOsztalyId" [tanev]="tanev"
                                [admin]="admin"></app-of-kesve-mulasztas>
      </ion-col>
    </ion-row>

    <!--  ══════════════════════════════════════════════════════════════════════
          ELBÍRÁLÁSRA VÁR – MINDEN osztályodról egy helyen, osztály-választótól függetlenül.
          Tömör sorok: egy igazolás = egy sor (nap, tanuló, típus, melléklet), a döntés
          ugyanabban a sorban, jobbra.
          ══════════════════════════════════════════════════════════════════════ -->
    <ng-container *ngIf="nezet === 'elbiralas'">
      <ion-row>
        <ion-col size="12">
          <ion-card class="hero-card varo-card">
            <ion-card-header>
              <ion-card-subtitle>
                A gondviselők által beküldött orvosi és hivatalos igazolások, valamint az utólag
                feltöltött dokumentumok – minden osztályodból. Amíg nincs döntés, a nap nem kerül rá az órákra.
              </ion-card-subtitle>
            </ion-card-header>
            <ion-card-content>
              <div *ngIf="!varolista.length" class="ures">Nincs elbírálásra váró igazolás.</div>
              <div class="varo-sor" *ngFor="let i of varolista">
                <div class="varo-adat">
                  <div class="varo-fej">
                    <strong>{{ i.datum }}</strong>
                    <span>{{ i.tanulo_nev || i.oktazon }}</span>
                    <span class="halvany" *ngIf="i.osztaly_nev">{{ i.osztaly_nev }}</span>
                    <ion-chip outline="true" color="tertiary">{{ i.tipus_nev }}</ion-chip>
                    <ion-chip outline="true" color="medium" *ngIf="i.ujra_elbiralando">utólag feltöltött</ion-chip>
                  </div>
                  <div class="varo-mellekletek">
                    <span *ngIf="!i.csatolmanyok?.length" class="halvany">nincs melléklet</span>
                    <a *ngFor="let c of i.csatolmanyok" class="csatolmany" (click)="csatolmanyNyit(c)"
                       [title]="c.nev + ' (' + meret(c.meret) + ')'">
                      <ion-icon name="document-attach-outline"></ion-icon> {{ c.nev }}
                    </a>
                  </div>
                  <div class="halvany varo-megj" *ngIf="i.indoklas">„{{ i.indoklas }}"</div>
                  <div class="halvany varo-megj" *ngIf="i.elozo_elutasitas">Újra beadva – korábban: {{ i.elozo_elutasitas }}</div>
                </div>
                <div class="varo-dontes">
                  <ng-container *ngTemplateOutlet="igDontesSablon; context: { i: i }"></ng-container>
                </div>
              </div>
            </ion-card-content>
          </ion-card>
        </ion-col>
      </ion-row>
    </ng-container>

    <ng-container *ngIf="nezet === 'hianyzas'">

    <!--  ══════════════════════════════════════════════════════════════════════
          AMI RÁM VÁR. Az elbírálásra váró orvosi igazolás eddig csak akkor került az
          osztályfőnök szeme elé, ha épp azt az osztályt nyitotta meg, és végiggörgette
          a beküldött igazolások tábláját – egy papír így hetekig ülhetett elintézetlenül,
          miközben a szülő azt látta, hogy beadta és nem történik semmi.

          Ez a kártya fordítva áll neki: MINDEN osztályáról egy helyen, elöl. Akkor is,
          ha épp másik osztály van kiválasztva – ezért nem függ az osztály-választótól.
          ══════════════════════════════════════════════════════════════════════ -->
    <!--  Az elbírálásra váró igazolások saját fülön vannak (lent); itt csak jelezzük, hogy
          teendő van – a hiányzás-nézet ne egy hosszú kártyával induljon. -->
    <ion-row *ngIf="varolista.length">
      <ion-col size="12">
        <div class="varo-jelzes" (click)="nezetValt('elbiralas')">
          <ion-icon name="alert-circle-outline"></ion-icon>
          <span><b>{{ varolista.length }}</b> beküldött igazolás vár elbírálásra.</span>
          <a>Megnyitás</a>
        </div>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col size="12">
        <ion-card class="hero-card">
          <ion-card-header>
            <ion-card-title>Osztályfőnöki hiányzás-összesítő</ion-card-title>
            <ion-card-subtitle>
              Éves hiányzás névsor szerint, igazolt / igazolatlan / elbírálatlan bontásban (egység: tanóra).
              A késések ideje összeadódik: 45 perc késés 1 órának számít, és benne van az összegekben.
              <span *ngIf="tanev"> &middot; {{ tanev }}/{{ tanev + 1 }}. tanév</span>
              <span *ngIf="admin"> &middot; admin nézet (összes osztály)</span>
            </ion-card-subtitle>
          </ion-card-header>

          <ion-card-content>
            <div *ngIf="hiba" class="of-error">{{ hiba }}</div>

            <div class="of-toolbar" *ngIf="!loadingOsztalyok && osztalyok.length">
              <!--  EGY TANULÓ NAPRA BONTOTT MULASZTÁSA.
                    Ugyanaz, mint a névsor sorát kinyitni – csak névről is elérhetően.
                    A sor-kinyitást senki nem találta meg, mert semmi nem mutatta,
                    hogy a sor mögött van még valami. -->
              <ion-item lines="none" class="of-select" *ngIf="tanulok.length">
                <ion-label position="stacked">Tanuló összesítője (napra bontva)</ion-label>
                <ion-select [(ngModel)]="valasztottTanuloOkt" interface="popover"
                            placeholder="Válassz tanulót…">
                  <ion-select-option value="">– nincs kiválasztva –</ion-select-option>
                  <ion-select-option *ngFor="let t of tanulok" [value]="t.oktazon">
                    {{ t.tanulo_nev }} ({{ t.osszes }} óra)
                  </ion-select-option>
                </ion-select>
              </ion-item>
            </div>

            <div *ngIf="loadingOsztalyok" class="of-empty">
              <ion-spinner name="crescent"></ion-spinner> Osztályok betöltése…
            </div>

            <div *ngIf="!loadingOsztalyok && !osztalyok.length && !hiba" class="of-empty">
              Nincs megjeleníthető osztály. (Osztályfőnökként csak a saját osztályaid jelennek meg.)
            </div>

            <div *ngIf="!loadingOsztalyok && osztalyok.length">
              <div *ngIf="loadingOsszesito" class="of-empty">
                <ion-spinner name="crescent"></ion-spinner> Összesítő betöltése…
              </div>

              <!--  Letöltés: napra/órára bontott kimutatás (pl. a gyermekjóléti szolgálatnak). -->
              <div class="of-letoltes" *ngIf="!loadingOsszesito && tanulok.length">
                <ion-button size="small" fill="outline" [disabled]="letoltesFut" (click)="mulasztasLetoltes(false)">
                  <ion-icon slot="start" name="download-outline"></ion-icon> Mulasztások (Excel)
                </ion-button>
                <ion-button size="small" fill="outline" color="danger" [disabled]="letoltesFut" (click)="mulasztasLetoltes(true)">
                  <ion-icon slot="start" name="download-outline"></ion-icon> Csak igazolatlanok (Excel)
                </ion-button>
                <ion-spinner *ngIf="letoltesFut" name="dots"></ion-spinner>
                <span class="halvany">Napra és órára bontva: mikor, melyik órán, miből hiányzott.</span>
              </div>

              <div class="of-table-wrap" *ngIf="!loadingOsszesito">
                <table class="of-table">
                  <thead>
                    <tr>
                      <th class="col-nev">#</th>
                      <th class="col-nev">Tanuló</th>
                      <th class="num">Összes</th>
                      <th class="num igazolt">Igazolt</th>
                      <th class="num igazolatlan">Igazolatlan</th>
                      <th class="num elbiralatlan">Elbírálatlan</th>
                      <!--  A KÉSÉSBŐL ÖSSZEGYŰLT ÓRÁK. Már benne vannak az összes / igazolt /
                            igazolatlan számban; itt külön is látszik, mennyi jött késésből. -->
                      <th class="num" title="45 perc késés = 1 óra mulasztás; igazolt és igazolatlan külön gyűlik. Az összegekben már benne van.">Ebből késésből</th>
                      <th class="col-toggle"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container *ngFor="let t of tanulok; let i = index">
                      <tr class="of-row" [class.expanded]="isExpanded(t)" [class.of-kilepett]="t.kilepett" (click)="toggleRow(t)"
                          [title]="t.kilepett ? 'Már nem jár az osztályba (utolsó nap: ' + t.kilepett + ') – a hiányzásai lezárhatók' : ''">
                        <td class="col-nev muted">{{ i + 1 }}.</td>
                        <td class="col-nev"><app-profilkep class="nevsor-kep" tipus="tanulo" [azon]="t.oktazon" [nev]="t.tanulo_nev"></app-profilkep>{{ t.tanulo_nev }}<small *ngIf="t.kilepett" class="of-kilepett-jel"> · kilépett {{ t.kilepett }}</small></td>
                        <td class="num"><strong>{{ t.osszes }}</strong></td>
                        <td class="num igazolt">{{ t.igazolt }}</td>
                        <td class="num igazolatlan">{{ t.igazolatlan }}</td>
                        <td class="num elbiralatlan">{{ t.elbiralatlan }}</td>
                        <td class="num">
                          <ng-container *ngIf="kesesPerc(t.keses); else nincsKeses">
                            {{ t.keses?.ora_osszes }} óra <small class="muted">({{ kesesPerc(t.keses) }} perc)</small>
                          </ng-container>
                          <ng-template #nincsKeses><span class="muted">–</span></ng-template>
                        </td>
                        <!--  A sor kinyitható: ezt KI IS MONDJUK. A puszta nyíl senkinek
                              nem árulta el, hogy a sor mögött napra bontott lista van. -->
                        <td class="col-toggle of-reszlet-cella">
                          <span class="of-reszlet-gomb">
                            {{ isExpanded(t) ? 'bezár' : 'napra bontva' }}
                            <ion-icon [name]="isExpanded(t) ? 'chevron-up' : 'chevron-down'"></ion-icon>
                          </span>
                        </td>
                      </tr>
                      <tr class="of-detail" *ngIf="isExpanded(t)">
                        <td colspan="8">
                          <div class="of-detail-grid">
                            <div class="of-detail-title">Igazolt hiányzás típusonként ({{ t.tanulo_nev }}):</div>
                            <div class="of-chips">
                              <span class="of-chip" *ngFor="let tip of tipusok">
                                {{ tip.nev }}: <strong>{{ tipusErtek(t, tip.id) }}</strong>
                              </span>
                              <span class="of-chip" *ngIf="!tipusok.length">Nincs típus.</span>
                            </div>
                          </div>

                          <!--  KÉSÉSBŐL ADÓDÓ MULASZTÁS. 45 perc késés = 1 óra; az igazolt és az
                                igazolatlan perc külön gyűlik, a maradék a következő késéssel gyűlik tovább. -->
                          <div class="of-detail-grid" *ngIf="t.keses?.keses_db">
                            <div class="of-detail-title">Késésből ({{ t.keses?.keses_db }} késés, az összegekben már benne van):</div>
                            <div class="of-chips">
                              <span class="of-chip">
                                Igazolatlan: <strong>{{ t.keses?.ora_igazolatlan }} óra</strong>
                                ({{ t.keses?.perc_igazolatlan }} perc)
                              </span>
                              <span class="of-chip">
                                Igazolt: <strong>{{ t.keses?.ora_igazolt }} óra</strong>
                                ({{ t.keses?.perc_igazolt }} perc)
                              </span>
                              <span class="of-chip" *ngIf="t.keses?.maradek_igazolatlan">
                                még <strong>{{ t.keses?.kovetkezo_orahoz }} perc</strong> a következő igazolatlan óráig
                              </span>
                              <span class="of-chip" *ngIf="t.keses?.maradek_igazolt">
                                {{ t.keses?.maradek_igazolt }} igazolt perc még nem teljes óra
                              </span>
                            </div>
                          </div>

                          <!--  MIKOR ÉS MIBŐL HIÁNYZOTT. A végösszeg megmondja, mennyit, de
                                nem azt, hogy mikor – azt eddig a heti rácsban kellett
                                hétről hétre végiglapozni. -->
                          <div class="of-detail-grid">
                            <div class="of-detail-title">Mikor és miből hiányzott
                              <ion-button size="small" fill="clear" [disabled]="letoltesFut" (click)="$event.stopPropagation(); mulasztasLetoltes(false, t)">
                                <ion-icon slot="start" name="download-outline"></ion-icon> Letöltés (Excel)
                              </ion-button>
                              <!--  Az igazolások teljes előzménye (forrás, rögzítő) – of-igazolas-elozmeny. -->
                              <ion-button size="small" fill="clear" (click)="$event.stopPropagation(); elozmenyNyit(t)">
                                <ion-icon slot="start" name="time-outline"></ion-icon> Igazolások előzménye
                              </ion-button>
                            </div>
                            <div *ngIf="tanuloReszletFut" class="halvany">
                              <ion-spinner name="dots"></ion-spinner> Betöltés…
                            </div>
                            <div *ngIf="!tanuloReszletFut && tanuloReszletHiba" class="halvany">
                              {{ tanuloReszletHiba }}
                            </div>
                            <div *ngIf="!tanuloReszletFut && !tanuloReszletHiba && tanuloReszlet">
                              <div class="halvany" *ngIf="tanuloReszlet.megjegyzes">{{ tanuloReszlet.megjegyzes }}</div>
                              <div class="halvany" *ngIf="!tanuloReszlet.napok?.length && !tanuloReszlet.megjegyzes">
                                Ebben a tanévben nincs rögzített hiányzása.
                              </div>
                              <div class="of-nap" *ngFor="let n of tanuloReszlet.napok">
                                <div class="of-nap-fej">
                                  <strong>{{ n.datum }}</strong>
                                  <span class="halvany">{{ n.ora_db }} óra</span>
                                  <!--  VISSZAVONÁS. Rossz napra vagy rossz típussal kattintani
                                        mindennapos; eddig nem volt visszaút, mert a tömeges
                                        igazolás szándékosan csak az elbírálatlan órákhoz nyúl. -->
                                  <ion-button *ngIf="napElbiraltOrak(n)" size="small" fill="clear" color="medium"
                                              (click)="visszavonKerdes(n)">
                                    <ion-icon slot="start" name="arrow-undo-outline"></ion-icon>
                                    {{ visszavonNap === n.datum ? 'Mégsem' : 'Visszavonás' }}
                                  </ion-button>
                                  <!--  TÉVES HIÁNYZÁS TÖRLÉSE (#1057) – a nap összes órájáról. -->
                                  <ion-button *ngIf="hianyzasTorolheto" size="small" fill="clear" color="danger"
                                              [disabled]="hianyzasTorlesFut" (click)="hianyzasTorles(n)">
                                    <ion-icon slot="start" name="trash-outline"></ion-icon>
                                    Nap hiányzásainak törlése
                                  </ion-button>
                                </div>

                                <!--  A megerősítés kimondja, mi történik: a nap döntései eltűnnek,
                                      és a napra beadott szülői igazolás is visszavonásra kerül –
                                      különben a rendszer magától visszaírná az órákra. -->
                                <div class="of-visszavon" *ngIf="visszavonNap === n.datum">
                                  <div>
                                    Ezen a napon <strong>{{ napElbiraltOrak(n) }}</strong> elbírált óra van.
                                    A visszavonás törli róluk a döntést – az órák ismét
                                    <strong>igazolandóként</strong> jelennek meg. Ha a napra szülői
                                    igazolás is tartozott, azt is visszavonjuk, és a nap visszakerül
                                    a szülő keretébe (újra beadhatja).
                                  </div>
                                  <ion-input fill="outline" label="Indok (a szülő is látni fogja)"
                                             label-placement="stacked" [(ngModel)]="visszavonIndok"
                                             placeholder="pl. rossz napra került"></ion-input>
                                  <ion-button size="small" color="danger" (click)="visszavon(n)"
                                              [disabled]="visszavonFolyamatban">
                                    <ion-icon slot="start" name="arrow-undo-outline"></ion-icon>
                                    Igen, visszavonom
                                  </ion-button>
                                </div>

                                <div class="of-nap-orak">
                                  <ion-chip *ngFor="let o of n.orak" outline="true"
                                            [color]="reszletAllapotSzin(o.allapot)">
                                    <ion-label>
                                      {{ o.ora }}. {{ o.tantargy || 'óra' }}
                                      <span *ngIf="o.cel"> · {{ o.cel }}</span>
                                      <span *ngIf="o.tipus_nev"> — {{ o.tipus_nev }}</span>
                                      <span *ngIf="!o.tipus_nev && o.allapot === 'igazolatlan'"> — igazolatlan</span>
                                      <span *ngIf="!o.tipus_nev && o.allapot === 'elbiralatlan'"> — még nincs elbírálva</span>
                                    </ion-label>
                                    <!--  Egy óra tévesen rögzített hiányzásának törlése. -->
                                    <ion-icon *ngIf="hianyzasTorolheto && o.id" name="trash-outline" class="of-ora-torles"
                                              title="Hiányzás törlése erről az óráról"
                                              (click)="$event.stopPropagation(); hianyzasTorles(n, o)"></ion-icon>
                                  </ion-chip>
                                </div>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </ng-container>

                    <tr *ngIf="!tanulok.length">
                      <td colspan="8" class="of-empty">Nincs tanuló ebben az osztályban.</td>
                    </tr>
                  </tbody>
                  <tfoot *ngIf="tanulok.length">
                    <tr class="of-foot">
                      <td class="col-nev"></td>
                      <td class="col-nev"><strong>Összesen ({{ tanulok.length }} tanuló)</strong></td>
                      <td class="num"><strong>{{ osszesenOsszes }}</strong></td>
                      <td class="num igazolt"><strong>{{ osszesenIgazolt }}</strong></td>
                      <td class="num igazolatlan"><strong>{{ osszesenIgazolatlan }}</strong></td>
                      <td class="num elbiralatlan"><strong>{{ osszesenElbiralatlan }}</strong></td>
                      <td class="num"><strong>{{ osszesenKesesOra }} óra</strong>
                        <small class="muted" *ngIf="osszesenKesesPerc">({{ osszesenKesesPerc }} perc)</small></td>
                      <td class="col-toggle"></td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </ion-card-content>
        </ion-card>
      </ion-col>
    </ion-row>

    <!--  IGAZOLATLAN MULASZTÁS – ÉRTESÍTÉSEK (20/2012. EMMI r. 50. § (4), 51. §).
          Aki elérte a küszöböt, és melyik címzett felé kell még értesítés; az értesítés tényének
          rögzítése (dátum, mód, címzett). A nyomtatvány „Értesítve” oszlopa ebből töltődik. -->
    <ion-row *ngIf="!loadingOsztalyok && osztalyok.length">
      <ion-col size="12">
        <ion-card class="hero-card">
          <ion-card-header>
            <ion-card-title>
              Igazolatlan mulasztás – értesítések
              <ion-badge color="warning" *ngIf="iglNyitottDb">{{ iglNyitottDb }} tanulónál teendő</ion-badge>
            </ion-card-title>
            <ion-card-subtitle>
              A 20/2012. EMMI rendelet szerint: tanköteles tanulónál az első igazolatlan óránál a szülőt,
              10 óránál a család- és gyermekjóléti központot és a gyermekjóléti szolgálatot, 30 óránál a
              szabálysértési hatóságot és ismét a gyermekjóléti szolgálatot, 50 óránál a gyámhatóságot kell
              értesíteni. Nem tanköteles tanulónál 10 óránál a központot (kiskorúnál a szülőt is), és a
              jogviszony 30 óra fölött csak két írásbeli figyelmeztetés után szűnik meg. Az értesítést itt
              <b>rögzítsd</b> (dátum, mód, címzett) – a rendszer addig jelez.
              <span *ngIf="iglAdat?.allapot"> &middot; állapot: {{ iglNap(iglAdat?.allapot) }}</span>
            </ion-card-subtitle>
          </ion-card-header>
          <ion-card-content>
            <div *ngIf="iglFut" class="of-empty">Betöltés…</div>
            <div *ngIf="iglHiba" class="of-error">{{ iglHiba }}</div>
            <div *ngIf="!iglFut && !iglHiba && iglAdat && !iglAdat.tanulok.length" class="of-empty">
              Az osztályban ebben a tanévben nincs igazolatlan óra.
            </div>

            <div class="igl-tanulo" *ngFor="let t of iglAdat?.tanulok || []" [class.igl-nyitott]="t.nyitott > 0">
              <div class="igl-fej">
                <b>{{ t.nev }}</b>
                <span class="igl-ora">{{ t.igazolatlan }} igazolatlan óra</span>
                <span class="igl-halvany" *ngIf="t.igazolatlan_kesesbol"> (ebből késésből {{ t.igazolatlan_kesesbol }})</span>
                <span class="igl-halvany" *ngIf="t.igazolatlan_egyeb"> (ebből egyéb foglalkozáson {{ t.igazolatlan_egyeb }})</span>
                <ion-badge [color]="t.tankoteles ? 'primary' : 'medium'">
                  {{ t.tankoteles ? 'tanköteles' : 'nem tanköteles' }}<span *ngIf="t.tankot_vege"> ({{ t.tankoteles ? 'eddig: ' : 'vége: ' }}{{ iglNap(t.tankot_vege) }})</span>
                </ion-badge>
                <ion-badge color="medium" *ngIf="!t.kiskoru">nagykorú</ion-badge>
                <ion-badge color="medium" *ngIf="t.kilepett">kilépett: {{ iglNap(t.kilepett) }}</ion-badge>
                <ion-badge [color]="t.nyitott ? 'warning' : 'success'">{{ t.nyitott ? (t.nyitott + ' teendő') : 'rendben' }}</ion-badge>
              </div>

              <div class="igl-teendo" *ngFor="let td of t.teendok">
                <div class="igl-teendo-cim">
                  <ion-icon [name]="td.teljesitve ? 'checkmark-circle' : 'alert-circle-outline'"
                            [color]="td.teljesitve ? 'success' : 'warning'"></ion-icon>
                  <span>{{ td.cim }}</span>
                  <span class="igl-halvany"> ({{ td.jogalap }}; felelős: {{ td.felelos }})</span>
                </div>
                <div class="igl-cimzettek">
                  <span *ngFor="let c of td.csoportok" class="igl-cimzett" [class.igl-kesz]="c.teljesitve">
                    {{ c.nev }}<span *ngIf="c.teljesitve"> – {{ td.fajtak ? 'rögzítve' : 'értesítve' }} {{ iglNap(c.datum) }}</span>
                    <ion-button *ngIf="!c.teljesitve" size="small" fill="clear" (click)="iglRogzitNyit(t, td, c.kodok[0])">
                      Rögzítés
                    </ion-button>
                    <!--  51. § (3): ha az értesítés eredményes volt, megkeresés nem kell – ezt is rögzíteni lehet. -->
                    <ion-button *ngIf="!c.teljesitve && td.fajtak?.includes('ertesites_eredmenyes')" size="small" fill="clear"
                                (click)="iglRogzitNyit(t, td, 'szulo', 'ertesites_eredmenyes')">
                      Eredményes volt
                    </ion-button>
                  </span>
                  <ion-button *ngIf="td.nyomtatvany" size="small" fill="outline" (click)="iglNyomtatvany(td)">
                    <ion-icon name="document-text-outline" slot="start"></ion-icon>Nyomtatvány
                  </ion-button>
                </div>
                <div class="igl-halvany igl-megj" *ngIf="td.megjegyzes">{{ td.megjegyzes }}</div>
              </div>

              <div class="igl-megszunes" *ngIf="t.megszunes?.tobb">
                <ion-icon name="warning-outline" [color]="t.megszunes?.megallapithato ? 'danger' : 'warning'"></ion-icon>
                {{ t.megszunes?.ok }}
                <ion-button *ngIf="t.megszunes?.megallapithato && iglAdat?.jog?.admin" size="small" color="danger" fill="outline"
                            [routerLink]="['/admin/tanulo-kilepes']"
                            [queryParams]="{ tanulo: t.oktazon, ok_kod: t.megszunes?.kilepes_ok_kod }">
                  Kiléptetés
                </ion-button>
                <span class="igl-halvany" *ngIf="t.megszunes?.megallapithato && !iglAdat?.jog?.admin">
                  A kiléptetést az igazgató / adminisztrátor végzi (Admin › Kiléptetés, „Igazolatlan mulasztás miatt” ok).
                </span>
              </div>

              <!--  A rögzítő űrlap: a teendő (fajta, küszöb) adott, a címzett, a mód és a nap választható. -->
              <div class="igl-urlap" *ngIf="iglForm && iglForm.oktazon === t.oktazon">
                <div class="igl-urlap-cim"><b>Értesítés rögzítése:</b> {{ iglForm.cim }}</div>
                <div class="of-igazol-bar">
                  <ion-select label="Címzett" label-placement="stacked" [(ngModel)]="iglForm.cimzett" interface="popover" class="of-igazol-select">
                    <ion-select-option *ngFor="let c of iglKodok.cimzettek" [value]="c.kod">{{ c.nev }}</ion-select-option>
                  </ion-select>
                  <ion-select label="Mód" label-placement="stacked" [(ngModel)]="iglForm.mod" interface="popover" class="of-igazol-select">
                    <ion-select-option *ngFor="let m of iglKodok.modok" [value]="m.kod">{{ m.nev }}</ion-select-option>
                  </ion-select>
                  <ion-input type="date" label="Az értesítés napja" label-placement="stacked" [(ngModel)]="iglForm.datum"></ion-input>
                  <ion-input label="A címzett pontos neve (nem kötelező)" label-placement="stacked" [(ngModel)]="iglForm.cimzett_nev"
                             placeholder="pl. Gödöllői Család- és Gyermekjóléti Központ" [maxlength]="255"></ion-input>
                  <ion-input label="Megjegyzés (nem kötelező)" label-placement="stacked" [(ngModel)]="iglForm.megjegyzes"
                             placeholder="pl. tértivevény száma, ki vette át" [maxlength]="500"></ion-input>
                </div>
                <ion-button size="small" (click)="iglMent()" [disabled]="iglMentes">Mentés</ion-button>
                <ion-button size="small" fill="clear" (click)="iglForm = null">Mégse</ion-button>
              </div>

              <details class="igl-rogzitett" *ngIf="t.ertesitesek.length">
                <summary>Rögzített értesítések ({{ t.ertesitesek.length }})</summary>
                <div *ngFor="let e of t.ertesitesek" class="igl-sor" [class.igl-visszavont]="e.visszavonva">
                  {{ iglNap(e.datum) }} · {{ e.fajta_nev }}<span *ngIf="e.kuszob"> ({{ e.kuszob }} óra)</span>
                  · {{ e.cimzett_nev || e.cimzett_szoveg }} · {{ e.mod_nev }}
                  <span class="igl-halvany"> · rögzítette: {{ e.kiado || '–' }}</span>
                  <span *ngIf="e.dokumentum_id" class="igl-halvany"> · a kiadott nyomtatványhoz kötve</span>
                  <span *ngIf="e.megjegyzes"> · {{ e.megjegyzes }}</span>
                  <span *ngIf="e.visszavonva" class="igl-halvany"> – visszavonva: {{ e.visszavonas_oka }}</span>
                  <ion-button *ngIf="!e.visszavonva" size="small" fill="clear" color="danger" (click)="iglVisszavon(e)">Visszavonás</ion-button>
                </div>
              </details>
            </div>

            <p class="igl-halvany" *ngIf="iglAdat?.tanulok?.length">
              A kollégiumi elhelyezést és a gyermekvédelmi szakellátást a rendszer nem tartja nyilván: szakellátásban
              nevelkedő tanulónál a területi gyermekvédelmi szakszolgálat felé rögzített értesítés váltja ki a gyermekjóléti
              szolgálatot (10 óra), illetve a szabálysértési hatóságot (30 óra). A küszöb elérésekor az osztályfőnök és az
              igazgató rendszerüzenetet kap (küszöbönként és tanulónként egyszer).
            </p>
          </ion-card-content>
        </ion-card>
      </ion-col>
    </ion-row>

    <!--  A SZÜLŐI IGAZOLÁSOK. A leggyakoribb osztályfőnöki kérdés: „beküldte-e a szülő
          egyáltalán?" – ezért itt az elutasított és a már elfogadott is látszik. -->
    <ion-row *ngIf="!loadingOsztalyok && osztalyok.length">
      <ion-col size="12">
        <ion-card class="hero-card">
          <ion-card-header>
            <ion-card-title>A szülők beküldött igazolásai</ion-card-title>
            <ion-card-subtitle>
              Amit a gondviselők a saját felületükön beküldtek erre az osztályra – a
              jóváhagyottak és az elutasítottak is.
            </ion-card-subtitle>
          </ion-card-header>
          <ion-card-content>
            <div *ngIf="loadingIgazolasok">Betöltés…</div>
            <div *ngIf="!loadingIgazolasok && !igazolasok.length" class="ures">
              Ehhez az osztályhoz még nem küldtek be igazolást.
            </div>
            <div class="tabla-burok" *ngIf="!loadingIgazolasok && igazolasok.length">
              <table class="of-tabla">
                <thead>
                  <tr>
                    <th>Nap</th><th>Tanuló</th><th>Szülői keret</th><th>Fajta</th><th>Indoklás</th>
                    <th>Melléklet</th><th>Állapot</th><th>Beküldte</th><th>Beküldve</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let i of igazolasok">
                    <td>{{ i.datum }}</td>
                    <td>{{ i.tanulo_nev || i.oktazon }}</td>
                    <!--  MENNYIT HASZNÁLT EL MENNYIBŐL. A szülő tanévente csak korlátozott
                          számú napot igazolhat maga; enélkül az osztályfőnök nem tudta
                          megmondani, belefért-e még a nap, és mennyi van hátra. Csak az
                          ELFOGADOTT, át nem minősített gondviselői napok fogynak. -->
                    <td class="keret-cella">
                      <span *ngIf="i.keret_nap != null"
                            [class.keret-elfogyott]="i.keret_maradek === 0">
                        {{ i.keret_felhasznalt }} / {{ i.keret_nap }} nap
                      </span>
                      <span *ngIf="i.keret_nap == null" class="halvany">–</span>
                      <div class="halvany" *ngIf="i.keret_nap != null">
                        {{ i.keret_maradek ? 'még ' + i.keret_maradek + ' nap' : 'elfogyott' }}
                      </div>
                    </td>
                    <td>{{ i.tipus_nev || 'Gondviselői igazolás' }}</td>
                    <td>{{ i.indoklas || '–' }}</td>
                    <!--  A melléklet (orvosi igazolás fényképe) opcionális: ahol nincs,
                          ott gondolatjel áll, nem üres cella. -->
                    <td>
                      <span *ngIf="!i.csatolmanyok?.length" class="halvany">–</span>
                      <a *ngFor="let c of i.csatolmanyok" class="csatolmany"
                         (click)="csatolmanyNyit(c)" rel="noopener"
                         [title]="c.nev + ' (' + meret(c.meret) + ')'">
                        <ion-icon name="document-attach-outline"></ion-icon> {{ c.nev }}
                      </a>
                    </td>
                    <td>
                      <ion-chip [color]="igazolasAllapot(i.statusz).szin" outline="true">
                        {{ igazolasAllapot(i.statusz).szoveg }}
                      </ion-chip>
                      <!--  Az elutasítás indoka a szülőnek is szól: itt látszik, mit
                            közöltünk vele. -->
                      <div class="halvany" *ngIf="i.elbiralas_indok">{{ i.elbiralas_indok }}</div>

                      <!--  UTÓLAGOS IGAZOLÁS. Ha az osztályfőnök az ötödik nap után
                            igazolatlanra állította a napot, és a szülő utólag igazolta,
                            a szám csendben átbillen. Ezt ki kell mondani: a KRÉTA felé
                            az igazolatlan óra addigra már átment. -->
                      <div class="ig-utolagos" *ngIf="i.utolagos_orak">
                        <ion-icon name="swap-horizontal-outline"></ion-icon>
                        Utólag igazolva – {{ i.utolagos_orak }} korábban
                        <b>igazolatlan</b> óra íródott felül.
                      </div>

                      <!--  Ez a nap már járt egy kört: elutasítottuk, a szülő újra beadta. -->
                      <div class="ig-ujra" *ngIf="i.elozo_elutasitas">
                        <ion-icon name="refresh-outline"></ion-icon>
                        Újra beadva – korábban elutasítva: {{ i.elozo_elutasitas }}
                      </div>
                      <!--  A döntés-blokk KÖZÖS: ugyanez áll az „elbírálásra vár" kártyán is.
                            Egy helyen írva egy helyen is javul. -->
                      <ng-container *ngTemplateOutlet="igDontesSablon; context: { i: i }"></ng-container>
                    </td>
                    <td>{{ i.igenylo || '–' }}</td>
                    <td>{{ i.letrehozva | date:'yyyy. MM. dd. HH:mm' }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </ion-card-content>
        </ion-card>
      </ion-col>
    </ion-row>

    <ion-row *ngIf="!loadingOsztalyok && osztalyok.length && tanulok.length">
      <ion-col size="12">
        <ion-card class="hero-card">
          <ion-card-header>
            <ion-card-title>Igazolás időszakra (pl. kikérő)</ion-card-title>
            <ion-card-subtitle>
              Előre is megadható. A már beírt hiányzásokat azonnal igazolja, és az időszak napjaira
              <b>később beírt</b> hiányzás is magától igazolt lesz – nem kell újra ellenőrizni.
              Amin már más igazolás áll, az változatlan marad.
            </ion-card-subtitle>
          </ion-card-header>
          <ion-card-content>
            <div class="of-igazol-bar">
              <ion-select placeholder="Tanuló" [(ngModel)]="idoszak.oktazon" interface="popover" class="of-igazol-select">
                <ion-select-option *ngFor="let t of tanulok" [value]="t.oktazon">{{ t.tanulo_nev }}</ion-select-option>
              </ion-select>
              <ion-input type="date" label="Mettől" label-placement="stacked" [(ngModel)]="idoszak.tol"></ion-input>
              <ion-input type="date" label="Meddig" label-placement="stacked" [(ngModel)]="idoszak.ig"></ion-input>
              <ion-select placeholder="Igazolás típusa" [(ngModel)]="idoszak.tipus" interface="popover" class="of-igazol-select">
                <ion-select-option *ngFor="let tip of tipusok" [value]="tip.id">{{ tip.nev }}</ion-select-option>
              </ion-select>
              <ion-button size="small" (click)="mentIdoszak()"
                [disabled]="idoszakMentes || !idoszak.oktazon || !idoszak.tol || !idoszak.ig || idoszak.tipus == null">
                Igazolás mentése
              </ion-button>
            </div>
          </ion-card-content>
        </ion-card>
      </ion-col>
    </ion-row>

    <ion-row *ngIf="!loadingOsztalyok && osztalyok.length">
      <ion-col size="12">
        <ion-card class="hero-card">
          <ion-card-header>
            <ion-card-title>Elbírálatlan hiányzások részletezője</ion-card-title>
            <ion-card-subtitle>
              Tanulónként, mely napokon (és mely órákban) van még elbírálatlan hiányzás –
              vagyis ami se igazolt típusba, se igazolatlanba nincs besorolva.
            </ion-card-subtitle>
          </ion-card-header>

          <ion-card-content>
            <div *ngIf="loadingElb" class="of-empty">
              <ion-spinner name="crescent"></ion-spinner> Részletező betöltése…
            </div>

            <div *ngIf="!loadingElb && !elbiralatlanTanulok.length" class="of-empty">
              Nincs elbírálatlan hiányzás ebben az osztályban.
            </div>

            <div class="of-table-wrap" *ngIf="!loadingElb && elbiralatlanTanulok.length">
              <table class="of-table">
                <thead>
                  <tr>
                    <th class="col-nev">Tanuló</th>
                    <th class="num elbiralatlan">Elbírálatlan óra</th>
                    <th class="num">Érintett napok</th>
                    <th class="col-toggle"></th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngFor="let t of elbiralatlanTanulok">
                    <tr class="of-row" [class.expanded]="isElbExpanded(t)" [class.of-kilepett]="t.kilepett" (click)="toggleElb(t)">
                      <td class="col-nev">
                        <app-profilkep class="nevsor-kep" tipus="tanulo" [azon]="t.oktazon" [nev]="t.tanulo_nev"></app-profilkep>{{ t.tanulo_nev }}<small *ngIf="t.kilepett" class="of-kilepett-jel"> · kilépett {{ t.kilepett }}</small>
                        <ion-badge *ngIf="+(t.egyeni_tanrend || 0)" color="tertiary" class="of-magan-jel">magántanuló</ion-badge>
                      </td>
                      <td class="num elbiralatlan"><strong>{{ t.osszes_elbiralatlan }}</strong></td>
                      <td class="num">{{ t.napok.length }}</td>
                      <td class="col-toggle">
                        <ion-icon [name]="isElbExpanded(t) ? 'chevron-up' : 'chevron-down'"></ion-icon>
                      </td>
                    </tr>
                    <tr class="of-detail" *ngIf="isElbExpanded(t)">
                      <td colspan="4">
                        <div class="of-detail-grid">
                          <div class="of-detail-title">
                            Pipáld ki a napokat, válaszd ki az igazolás típusát, majd mentsd – a kijelölt
                            napok <b>összes</b> óráját beírjuk, a csoportbontásos (nyelvi, fakultációs)
                            órákat is. Az igazolás (orvosi, kikérő, hivatalos…) a korábban
                            <b>igazolatlannak</b> vett órákat is felülírja; amin már más igazolás áll,
                            az változatlan marad. Az <b>Igazolatlan</b> csak a még el nem bírált órákra
                            kerül rá – meglévő igazolást nem töröl.
                          </div>

                          <label class="of-nap-select-all">
                            <ion-checkbox
                              [checked]="mindenNapKijelolve(t)"
                              (ionChange)="toggleMindenNap(t, $event)"
                            ></ion-checkbox>
                            Összes nap kijelölése
                          </label>

                          <div class="of-nap" *ngFor="let n of t.napok">
                            <label class="of-nap-datum">
                              <ion-checkbox
                                [checked]="isNapSelected(n.datum)"
                                (ionChange)="toggleNap(n.datum, $event)"
                              ></ion-checkbox>
                              {{ n.datum }} <span class="muted">({{ n.ora_db }} óra)</span>
                            </label>
                            <div class="of-chips">
                              <span class="of-chip" *ngFor="let o of n.orak">
                                {{ o.ora }}. óra<span *ngIf="o.tantargy"> &middot; {{ o.tantargy }}</span>
                                <!--  Magántanulónál óránként is törölhető (egyéni tanrend). -->
                                <ion-icon *ngIf="+(t.egyeni_tanrend || 0) && hianyzasTorolheto && o.id"
                                          name="trash-outline" class="of-ora-torles" title="Hiányzás törlése"
                                          (click)="$event.stopPropagation(); magantanuloHianyzasTorles(t, n, o)"></ion-icon>
                              </span>
                            </div>
                          </div>

                          <div class="of-igazol-bar">
                            <ion-select
                              placeholder="Igazolás típusa"
                              [(ngModel)]="elbIgazolasTipus"
                              interface="popover"
                              class="of-igazol-select"
                            >
                              <ion-select-option *ngFor="let tip of tipusok" [value]="tip.id">
                                {{ tip.nev }}
                              </ion-select-option>
                              <ion-select-option [value]="-2">Igazolatlan</ion-select-option>
                            </ion-select>
                            <ion-button
                              size="small"
                              (click)="mentElbIgazolas(t)"
                              [disabled]="elbMentesFolyamatban || !elbSelectedNapok.size || elbIgazolasTipus == null"
                            >
                              <ion-icon slot="start" name="save-outline"></ion-icon>
                              Kijelölt napok igazolása
                            </ion-button>
                            <!--  MAGÁNTANULÓ: az egyéni tanrendű tanuló nem jár órára – a téves
                                  hiányzás-jelölést az osztályfőnök törölheti is, nem csak igazolhatja. -->
                            <ion-button *ngIf="+(t.egyeni_tanrend || 0) && hianyzasTorolheto"
                              size="small" fill="outline" color="danger"
                              (click)="magantanuloHianyzasTorles(t)"
                              [disabled]="elbTorlesFut || !elbSelectedNapok.size"
                            >
                              <ion-icon slot="start" name="trash-outline"></ion-icon>
                              Kijelölt napok hiányzásának törlése
                            </ion-button>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </div>
          </ion-card-content>
        </ion-card>
      </ion-col>
    </ion-row>
    </ng-container>

    <!-- =====================================================================
         AZ OSZTÁLY JEGYEI – sor a tanuló, oszlop a tantárgy, a cellában a jegyek időrendben.
         ===================================================================== -->
    <ion-row *ngIf="nezet === 'jegyek' && !loadingOsztalyok && osztalyok.length">
      <ion-col size="12">
        <ion-card class="hero-card">
          <ion-card-header>
            <ion-card-title>Az osztály jegyei</ion-card-title>
            <ion-card-subtitle>
              Minden tanuló minden tárgyból kapott jegye, bármelyik tanár írta be – a csoportbontásos,
              más osztállyal közös órákon kapottak is. A tanuló nevére kattintva részletesen is látszik.
              <span *ngIf="jegyAdat?.tanev"> &middot; {{ jegyAdat.tanev.id }}/{{ jegyAdat.tanev.id + 1 }}. tanév</span>
            </ion-card-subtitle>
          </ion-card-header>

          <ion-card-content>
            <div class="of-jegy-szurok">
              <ion-segment class="of-idoszak" [value]="jegyIdoszak"
                           (ionChange)="jegyIdoszak = $any($event.detail.value); jegyMatrixEpit()">
                <ion-segment-button value="ev"><ion-label>Egész tanév</ion-label></ion-segment-button>
                <ion-segment-button value="f1"><ion-label>I. félév</ion-label></ion-segment-button>
                <ion-segment-button value="f2"><ion-label>II. félév</ion-label></ion-segment-button>
              </ion-segment>
              <ion-toggle [checked]="uresTargyakRejtve" labelPlacement="end"
                          (ionChange)="uresTargyakRejtve = $event.detail.checked; jegyMatrixEpit()">
                Jegy nélküli tantárgyak elrejtése
              </ion-toggle>
              <ion-segment class="of-jegy-nezet" [value]="jegyNezet"
                           (ionChange)="jegyNezetValt($any($event.detail.value))">
                <ion-segment-button value="osztaly"><ion-label>Osztály</ion-label></ion-segment-button>
                <ion-segment-button value="tanulo"><ion-label>Tanulónként</ion-label></ion-segment-button>
              </ion-segment>
              <ion-button fill="clear" size="small" (click)="loadJegyek()" [disabled]="loadingJegyek">
                <ion-icon slot="start" name="refresh-outline"></ion-icon>Frissítés
              </ion-button>
            </div>

            <div *ngIf="loadingJegyek" class="of-empty">
              <ion-spinner name="crescent"></ion-spinner> Jegyek betöltése…
            </div>
            <div *ngIf="!loadingJegyek && jegyHiba" class="of-error">{{ jegyHiba }}</div>

            <ng-container *ngIf="!loadingJegyek && !jegyHiba && jegyAdat">
              <div *ngIf="!jegySorok.length" class="of-empty">
                Ebben az osztályban nincs aktív jogviszonyú tanuló.
              </div>
              <div *ngIf="jegySorok.length && !jegyOszlopok.length" class="of-empty">
                Ebben az időszakban még nincs jegy, és az osztály órarendjében sincs tantárgy.
              </div>

              <!-- TANULÓNKÉNT: sor a tantárgy, oszlop a hónap – mint a KRÉTA tanulói értékelés-nézete. -->
              <div class="of-tn" *ngIf="jegyNezet === 'tanulo' && jegySorok.length && jegyOszlopok.length">
                <div class="of-tn-valaszto">
                  <ion-button fill="clear" size="small" (click)="tanuloLeptet(-1)" [disabled]="tanuloNezetIndex <= 0"
                              title="Előző tanuló"><ion-icon slot="icon-only" name="chevron-back-outline"></ion-icon></ion-button>
                  <app-profilkep tipus="tanulo" [azon]="tanuloNezetOkt" [nev]="tanuloNezetSor?.tanulo_nev || ''" [meret]="36"></app-profilkep>
                  <select [ngModel]="tanuloNezetOkt" (ngModelChange)="tanuloValaszt($event)">
                    <option *ngFor="let s of jegySorok; let i = index" [value]="s.oktazon">{{ i + 1 }}. {{ s.tanulo_nev }}</option>
                  </select>
                  <ion-button fill="clear" size="small" (click)="tanuloLeptet(1)" [disabled]="tanuloNezetIndex >= jegySorok.length - 1"
                              title="Következő tanuló"><ion-icon slot="icon-only" name="chevron-forward-outline"></ion-icon></ion-button>
                  <span class="halvany" *ngIf="tanuloNezetSor as ts">
                    {{ ts.jegyDb }} jegy<span *ngIf="ts.osszAtlag"> · átlagok átlaga: <b>{{ ts.osszAtlag }}</b></span>
                    <span *ngIf="ts.gyengeTargyak"> · {{ ts.gyengeTargyak }} tárgyból gyenge</span>
                  </span>
                </div>
                <div class="of-jm-wrap">
                  <table class="of-jm of-tn-tabla">
                    <thead>
                      <tr>
                        <th class="of-jm-nev">Tantárgy</th>
                        <th *ngFor="let h of tanuloNezetOszlopok" [class.of-tn-zaro]="h.zaro">{{ h.n }}</th>
                        <th class="of-jm-ossz">Átlag</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let r of tanuloNezetSorok" [class.of-tn-ures]="!r.db">
                        <th class="of-jm-nev" scope="row">{{ r.tantargy_nev }}</th>
                        <td *ngFor="let h of tanuloNezetOszlopok" class="of-jm-cella" [class.of-tn-zaro]="h.zaro">
                          <span *ngFor="let j of r.cellak[h.k] || []; trackBy: trackJegy" class="of-jegy"
                                [ngClass]="h.zaro ? 'of-jegy-zaro' : (j.sulyOsztaly || '')"
                                [style.color]="h.zaro ? null : j.szinCss" [title]="j.cim" [attr.data-negyedev]="(!h.zaro && j.jel) || null"><small *ngIf="j.jel && !h.zaro" class="of-jegy-jel">{{ j.jel }}</small>{{ j.rovid }}</span>
                        </td>
                        <td class="of-jm-ossz"><span class="of-jm-atlag" [class.gyenge]="r.gyenge">{{ r.atlag || '–' }}</span></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="of-jm-wrap" *ngIf="jegyNezet === 'osztaly' && jegySorok.length && jegyOszlopok.length">
                <table class="of-jm">
                  <thead>
                    <tr>
                      <th class="of-jm-nev">Tanuló</th>
                      <th *ngFor="let o of jegyOszlopok; trackBy: trackTargy" class="of-jm-targy"
                          [title]="o.tantargy_nev + (o.orarendi ? '' : ' – nincs az osztály órarendjében, de van belőle jegy')">
                        {{ o.tantargy_nev }}
                      </th>
                      <th class="of-jm-ossz" title="A tantárgyi átlagok átlaga – csak az érdemjegyes tárgyakból">
                        Átlagok átlaga
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let s of jegySorok; let i = index; trackBy: trackTanulo">
                      <th class="of-jm-nev" scope="row">
                        <button type="button" class="of-jm-nevgomb" (click)="reszletNyit(s)"
                                title="A tanuló jegyei részletesen">
                          <span class="muted">{{ i + 1 }}.</span> <app-profilkep class="nevsor-kep" tipus="tanulo" [azon]="s.oktazon" [nev]="s.tanulo_nev"></app-profilkep>{{ s.tanulo_nev }}
                        </button>
                        <div class="of-jm-alinfo" *ngIf="s.gyengeTargyak">
                          <ion-icon name="warning-outline"></ion-icon>
                          {{ s.gyengeTargyak }} tárgyból gyenge az átlaga
                        </div>
                      </th>
                      <td *ngFor="let o of jegyOszlopok; trackBy: trackTargy" class="of-jm-cella">
                        <ng-container *ngIf="s.cellak[o.tantargy_id] as c">
                          <div class="of-jm-jegyek" *ngIf="c.evkozi.length || c.zaro.length; else nincsJegy">
                            <span *ngFor="let j of c.evkozi; trackBy: trackJegy" class="of-jegy" [ngClass]="j.sulyOsztaly || ''"
                                  [style.color]="j.szinCss" [title]="j.cim" [attr.data-negyedev]="j.jel || null"><small *ngIf="j.jel" class="of-jegy-jel">{{ j.jel }}</small>{{ j.rovid }}</span>
                            <span *ngFor="let j of c.zaro; trackBy: trackJegy" class="of-jegy of-jegy-zaro"
                                  [title]="j.cim"><small class="of-jegy-jel">{{ j.zaro }}</small>{{ j.rovid }}</span>
                          </div>
                          <div class="of-jm-atlag" *ngIf="c.atlagSzoveg" [class.gyenge]="c.gyenge" title="átlag">
                            ⌀ {{ c.atlagSzoveg }}
                          </div>
                        </ng-container>
                      </td>
                      <td class="of-jm-ossz"><strong>{{ s.osszAtlag || '–' }}</strong></td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <th class="of-jm-nev" scope="row">Osztályátlag</th>
                      <td *ngFor="let o of jegyOszlopok; trackBy: trackTargy" class="of-jm-cella">
                        <strong>{{ jegyLabAtlag[o.tantargy_id] || '–' }}</strong>
                      </td>
                      <td class="of-jm-ossz"></td>
                    </tr>
                  </tfoot>
                </table>
              </div>
              <ng-template #nincsJegy><span class="muted">–</span></ng-template>

              <!--  JELMAGYARÁZAT. A szín a számonkérés típusa (mint a szülői és a szaktanári
                    nézetben), a részletek a jegyre állva vagy a névre kattintva látszanak. -->
              <div class="of-jelmagyarazat" *ngIf="jegySorok.length && jegyOszlopok.length">
                <span *ngFor="let t of jegyTipusok" class="of-jm-elem">
                  <span class="of-jegy" [style.color]="t.szin">5</span> {{ t.nev }}
                </span>
                <span class="of-jm-elem"><span class="of-jegy dupla">5</span> dupla súlyú</span>
                <span class="of-jm-elem"><span class="of-jegy nulla">5</span> nem számít az átlagba</span>
                <span class="of-jm-elem"><span class="of-jegy" data-negyedev="N1"><small class="of-jegy-jel">N1</small>4</span><span class="of-jegy" data-negyedev="N2"><small class="of-jegy-jel">N2</small>4</span><span class="of-jegy" data-negyedev="N3"><small class="of-jegy-jel">N3</small>4</span><span class="of-jegy" data-negyedev="N4"><small class="of-jegy-jel">N4</small>4</span> negyedéves</span>
                <span class="of-jm-elem"><span class="of-jegy of-jegy-zaro"><small class="of-jegy-jel">F</small>4</span> félévi,
                  <span class="of-jegy of-jegy-zaro"><small class="of-jegy-jel">É</small>4</span> év végi</span>
                <span class="of-jm-elem"><span class="of-jm-atlag gyenge">⌀ 1,8</span> 2,0 (százaléknál 50%) alatti átlag</span>
                <div class="halvany">
                  Az átlag a kiválasztott időszak évközi jegyeiből számol, súlyozva; a félévi, az év végi
                  és a negyedéves értékelés nem számít bele. Egy jegyre állva látszik a dátuma, típusa,
                  súlya, témája és a tanára.
                  <span *ngIf="jegyNelkuliTanulok"> {{ jegyNelkuliTanulok }} tanulónak ebben az időszakban még nincs jegye.</span>
                </div>
              </div>
            </ng-container>
          </ion-card-content>
        </ion-card>
      </ion-col>
    </ion-row>

    <!-- =====================================================================
         „IKSZES ÓRÁK" – a tanórai jelölések és a feljegyzések, típus és idő szerint szűrve.
         ===================================================================== -->
    <ion-row *ngIf="nezet === 'ikszek' && !loadingOsztalyok && osztalyok.length">
      <ion-col size="12">
        <ion-card class="hero-card">
          <ion-card-header>
            <ion-card-title>Tanórai feljegyzések („ikszes órák")</ion-card-title>
            <ion-card-subtitle>
              Amit a tanárok az órán a tanulónál jelöltek – felszerelés hiány, házi feladat hiány,
              felmentés, tanórai dicséret –, és a tanulókról írt feljegyzések, bármelyik órán (a
              csoportbontásosakon is). Hogy mi számítson, a típusokra kattintva választható.
            </ion-card-subtitle>
          </ion-card-header>

          <ion-card-content>
            <div *ngIf="loadingIkszek" class="of-empty">
              <ion-spinner name="crescent"></ion-spinner> Tanórai feljegyzések betöltése…
            </div>
            <div *ngIf="!loadingIkszek && ikszHiba" class="of-error">{{ ikszHiba }}</div>

            <ng-container *ngIf="!loadingIkszek && !ikszHiba && ikszAdat">
              <div class="of-iksz-tipusok">
                <div class="of-iksz-gyors">
                  <span class="halvany">Típusok (a szám a választott időszakra szól):</span>
                  <ion-button size="small" fill="clear" (click)="ikszTipusCsoport('ikszes')">csak a hiányok</ion-button>
                  <ion-button size="small" fill="clear" (click)="ikszTipusCsoport('mind')">mind</ion-button>
                  <ion-button size="small" fill="clear" (click)="ikszTipusCsoport('semmi')">egyik sem</ion-button>
                  <ion-button size="small" fill="clear" (click)="loadIkszek()">
                    <ion-icon slot="start" name="refresh-outline"></ion-icon>Frissítés
                  </ion-button>
                </div>
                <ion-chip *ngFor="let t of ikszTipusok" (click)="ikszTipusValt(t.kulcs)"
                          [outline]="!ikszKivalasztott.has(t.kulcs)"
                          [color]="ikszKivalasztott.has(t.kulcs) ? ikszSzin(t.kulcs) : 'medium'"
                          [class.of-iksz-ures]="!ikszTipusDb[t.kulcs]"
                          [title]="t.leiras || (t.forras === 'ora' ? 'A napló névsorában, az órán jelölve (és az azonos nevű feljegyzés)' : 'Feljegyzés')">
                  <ion-icon *ngIf="t.ikon" [name]="t.ikon"></ion-icon>
                  <ion-label>{{ t.nev }} <strong>{{ ikszTipusDb[t.kulcs] || 0 }}</strong></ion-label>
                </ion-chip>
              </div>

              <div class="of-iksz-szurok">
                <ion-input type="date" fill="outline" label="Ettől" labelPlacement="stacked"
                           [(ngModel)]="ikszTol" (ionChange)="ikszSzur()"
                           [min]="ikszAdat.tanev?.tol" [max]="ikszAdat.tanev?.ig"></ion-input>
                <ion-input type="date" fill="outline" label="Eddig" labelPlacement="stacked"
                           [(ngModel)]="ikszIg" (ionChange)="ikszSzur()"
                           [min]="ikszAdat.tanev?.tol" [max]="ikszAdat.tanev?.ig"></ion-input>
                <ion-select fill="outline" label="Tanuló" labelPlacement="stacked" interface="popover"
                            [(ngModel)]="ikszTanulo" (ionChange)="ikszSzur()">
                  <ion-select-option value="">Mindenki</ion-select-option>
                  <ion-select-option *ngFor="let s of ikszSorok; trackBy: trackTanulo" [value]="s.oktazon">
                    {{ s.tanulo_nev }}
                  </ion-select-option>
                </ion-select>
                <ion-button size="small" fill="outline" *ngIf="ikszTol || ikszIg || ikszTanulo" (click)="ikszSzuroTorol()">
                  Szűrők törlése
                </ion-button>
              </div>

              <div *ngIf="!ikszAdat.bejegyzesek?.length" class="ures">
                Ebben a tanévben ennél az osztálynál még nincs tanórai jelölés vagy feljegyzés.
              </div>

              <h3 class="of-alcim">Tanulónként</h3>
              <div *ngIf="!ikszKivalasztott.size" class="ures">Nincs kijelölt típus – válassz fent legalább egyet.</div>
              <div *ngIf="ikszKivalasztott.size && !ikszOszlopok.length" class="ures">
                A kijelölt típusokban ebben az időszakban nincs bejegyzés.
              </div>
              <div class="of-table-wrap" *ngIf="ikszOszlopok.length">
                <table class="of-table of-iksz-tabla">
                  <thead>
                    <tr>
                      <th class="col-nev">Tanuló</th>
                      <th class="num" *ngFor="let t of ikszOszlopok">{{ t.nev }}</th>
                      <th class="num">Összesen</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let s of ikszSorok; trackBy: trackTanulo" class="of-row"
                        [class.expanded]="ikszTanulo === s.oktazon" [class.of-iksz-nulla]="!s.ossz"
                        (click)="ikszTanuloValt(s.oktazon)" title="Kattintásra csak ennek a tanulónak a bejegyzései">
                      <td class="col-nev"><app-profilkep class="nevsor-kep" tipus="tanulo" [azon]="s.oktazon" [nev]="s.tanulo_nev"></app-profilkep>{{ s.tanulo_nev }}</td>
                      <td class="num" *ngFor="let t of ikszOszlopok" [class.of-iksz-van]="!!s.db[t.kulcs]">
                        {{ s.db[t.kulcs] || '' }}
                      </td>
                      <td class="num"><strong>{{ s.ossz || '–' }}</strong></td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr class="of-foot">
                      <td class="col-nev"><strong>Összesen</strong></td>
                      <td class="num" *ngFor="let t of ikszOszlopok"><strong>{{ ikszTipusDb[t.kulcs] || 0 }}</strong></td>
                      <td class="num"><strong>{{ ikszOsszesen }}</strong></td>
                    </tr>
                  </tfoot>
                </table>
              </div>

              <h3 class="of-alcim">
                Időrendben
                <span class="halvany">– a legfrissebb elöl<span *ngIf="ikszTanulo"> · {{ ikszTanuloNev }}</span> · {{ ikszLista.length }} tétel</span>
              </h3>
              <div *ngIf="ikszKivalasztott.size && !ikszLista.length" class="ures">A szűrésnek megfelelő bejegyzés nincs.</div>
              <div class="tabla-burok" *ngIf="ikszLista.length">
                <table class="of-tabla">
                  <thead>
                    <tr><th>Dátum</th><th>Óra</th><th>Tantárgy</th><th>Tanár</th><th>Tanuló</th><th>Típus</th><th>Megjegyzés</th></tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let b of ikszLista">
                      <td class="nowrap">{{ b.datum }}<span *ngIf="b.ido" class="halvany"> {{ b.ido }}</span></td>
                      <td class="nowrap">{{ b.ora ? b.ora + '. óra' : '–' }}</td>
                      <td>
                        {{ b.tantargy || '–' }}
                        <div class="halvany" *ngIf="b.cel && b.cel !== aktivOsztaly?.osztaly_nev">{{ b.cel }}</div>
                      </td>
                      <td>{{ b.tanar_nev || '–' }}</td>
                      <td>{{ b.tanulo_nev }}</td>
                      <td>
                        <ion-chip class="of-iksz-chip" outline="true" [color]="ikszSzin(b.kulcs)">
                          <ion-icon *ngIf="ikszTipus(b.kulcs)?.ikon" [name]="ikszTipus(b.kulcs)?.ikon || ''"></ion-icon>
                          <ion-label>{{ ikszTipus(b.kulcs)?.nev || b.kulcs }}</ion-label>
                        </ion-chip>
                        <div class="halvany">{{ b.forras === 'ora' ? 'órán jelölve' : 'feljegyzés' }}{{ b.kreta ? ' · KRÉTA' : '' }}</div>
                      </td>
                      <td>
                        <span *ngIf="b.megjegyzes">{{ b.megjegyzes }}</span>
                        <div class="halvany" *ngIf="b.tema">Az óra témája: {{ b.tema }}</div>
                        <span *ngIf="!b.megjegyzes && !b.tema" class="halvany">–</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </ng-container>
          </ion-card-content>
        </ion-card>
      </ion-col>
    </ion-row>

    <!--  ══════════════════════════════════════════════════════════════════════
          SNI / BTMN – a saját osztály tanulóinak szakértői véleményei (20/2012. EMMI r. 95. § (5)):
          a beírási napló adata. Az osztályfőnök rögzíthet és módosíthat; a törlés adminé (a
          kiszolgáló dönt: backend/szakertoi-velemeny.js).
          ══════════════════════════════════════════════════════════════════════ -->
    <ion-row *ngIf="nezet === 'szakvelemeny' && !loadingOsztalyok && osztalyok.length">
      <ion-col size="12">
        <ion-card class="hero-card">
          <ion-card-header>
            <ion-card-title>Szakértői vélemények (SNI / BTMN)</ion-card-title>
            <ion-card-subtitle>
              A beírási naplóba kerülő adatok: a kiállító szakértői bizottság neve és címe, a vélemény száma
              és kelte, a felülvizsgálatok és a következő kötelező felülvizsgálat. Minden felülvizsgálat új
              sor. A KRÉTA-adatból egy gombbal átvehető.
            </ion-card-subtitle>
          </ion-card-header>

          <ion-card-content>
            <div *ngIf="loadingSzv" class="of-empty">
              <ion-spinner name="crescent"></ion-spinner> Szakértői vélemények betöltése…
            </div>
            <div *ngIf="!loadingSzv && szvHiba" class="of-error">{{ szvHiba }}</div>

            <ng-container *ngIf="!loadingSzv && !szvHiba && szvAdat">
              <div class="of-szv-eszkozok">
                <ion-checkbox labelPlacement="end" [(ngModel)]="szvCsakErintett">Csak az érintett tanulók</ion-checkbox>
                <ion-button size="small" fill="clear" (click)="loadSzv()">
                  <ion-icon slot="start" name="refresh-outline"></ion-icon>Frissítés
                </ion-button>
              </div>
              <div *ngIf="!szvTanulok.length" class="of-empty">
                {{ szvCsakErintett ? 'Az osztályban nincs szakértői véleménnyel nyilvántartott tanuló.' : 'Az osztályban nincs tanuló.' }}
              </div>

              <div class="of-szv-tanulo" *ngFor="let t of szvTanulok" [class.nyitott]="szvNyitott === t.oktazon">
                <div class="of-szv-fej" (click)="szvNyit(t.oktazon)">
                  <app-profilkep class="nevsor-kep" tipus="tanulo" [azon]="t.oktazon" [nev]="t.tanulo_nev"></app-profilkep>
                  <b>{{ t.tanulo_nev }}</b>
                  <span class="of-szv-osszeg">
                    <ng-container *ngIf="t.velemenyek.length; else nincsSajat">
                      <ion-chip *ngFor="let tp of szvTipusai(t)" color="primary" [outline]="true">{{ tp }}</ion-chip>
                      <span class="halvany" *ngIf="szvKovetkezo(t) as kov">köv. felülvizsgálat: {{ kov }}</span>
                    </ng-container>
                    <ng-template #nincsSajat>
                      <span class="halvany" *ngIf="t.kreta.length">csak KRÉTA-adat ({{ szvKretaTipusai(t) }})</span>
                      <span class="halvany" *ngIf="!t.kreta.length">–</span>
                    </ng-template>
                  </span>
                  <ion-icon [name]="szvNyitott === t.oktazon ? 'chevron-up-outline' : 'chevron-down-outline'"></ion-icon>
                </div>

                <div class="of-szv-reszlet" *ngIf="szvNyitott === t.oktazon">
                  <table class="of-szv-tabla" *ngIf="t.velemenyek.length">
                    <thead><tr><th>Típus</th><th>Kiállító bizottság</th><th>Szám, kelt</th><th>Köv. felülvizsgálat</th><th>Megnevezés, javaslat</th><th></th></tr></thead>
                    <tbody>
                      <tr *ngFor="let v of t.velemenyek">
                        <td><b>{{ v.tipus }}</b><div *ngIf="+v.felulvizsgalat" class="halvany">felülvizsgálat</div><div *ngIf="v.forras === 'kreta'" class="halvany">KRÉTA-ból átvéve</div></td>
                        <td>{{ v.bizottsag_nev || '–' }}<div *ngIf="v.bizottsag_cim" class="halvany">{{ v.bizottsag_cim }}</div></td>
                        <td>{{ v.velemeny_szam || '–' }}<div class="halvany">{{ v.kelt || '' }}</div></td>
                        <td>{{ v.kovetkezo_felulvizsgalat || v.ervenyesseg || '–' }}</td>
                        <td>{{ v.fogyatekossag || '–' }}<div *ngIf="v.javaslat" class="halvany">{{ v.javaslat }}</div></td>
                        <td>
                          <ion-button *ngIf="szvAdat.jog?.iras" size="small" fill="clear" (click)="szvSzerkeszt(t, v)" title="Módosítás">
                            <ion-icon slot="icon-only" name="create-outline"></ion-icon>
                          </ion-button>
                          <ion-button *ngIf="szvAdat.jog?.torles" size="small" fill="clear" color="danger" (click)="szvTorol(v)" title="Törlés">
                            <ion-icon slot="icon-only" name="trash-outline"></ion-icon>
                          </ion-button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div *ngIf="!t.velemenyek.length && !szvUrlap" class="halvany">
                    Még nincs rögzített szakértői vélemény. A beírási napló addig a KRÉTA-adatot mutatja (ha van).
                  </div>

                  <div *ngIf="szvAdat.jog?.iras && !szvUrlap" class="of-szv-gombok">
                    <ion-button size="small" fill="outline" (click)="szvUj(t)">
                      <ion-icon slot="start" name="add-outline"></ion-icon>Új szakértői vélemény / felülvizsgálat
                    </ion-button>
                    <ion-button size="small" fill="outline" color="medium" *ngFor="let k of t.kreta" (click)="szvUj(t, k)">
                      <ion-icon slot="start" name="download-outline"></ion-icon>Átvétel a KRÉTA-adatból ({{ k.tipus }})
                    </ion-button>
                  </div>
                  <p class="halvany" *ngIf="!szvAdat.jog?.torles && t.velemenyek.length">
                    Téves sor törlését az adminisztrátor végezheti el.
                  </p>

                  <div *ngIf="szvUrlap && szvUrlapOkt === t.oktazon" class="of-szv-urlap">
                    <ion-select label="Típus" label-placement="stacked" fill="outline" interface="popover" [(ngModel)]="szvUrlap.tipus">
                      <ion-select-option value="SNI">SNI – sajátos nevelési igény</ion-select-option>
                      <ion-select-option value="BTMN">BTMN – beilleszkedési, tanulási, magatartási nehézség</ion-select-option>
                    </ion-select>
                    <ion-checkbox labelPlacement="end" [(ngModel)]="szvUrlap.felulvizsgalat">Felülvizsgálat eredménye</ion-checkbox>
                    <ion-input label="Kiállító szakértői bizottság neve" label-placement="stacked" fill="outline" maxlength="255" [(ngModel)]="szvUrlap.bizottsag_nev"></ion-input>
                    <ion-input label="A bizottság címe" label-placement="stacked" fill="outline" maxlength="255" [(ngModel)]="szvUrlap.bizottsag_cim"></ion-input>
                    <ion-input label="A vélemény száma" label-placement="stacked" fill="outline" maxlength="100" [(ngModel)]="szvUrlap.velemeny_szam"></ion-input>
                    <ion-input label="Kiállításának kelte" label-placement="stacked" fill="outline" type="date" [(ngModel)]="szvUrlap.kelt"></ion-input>
                    <ion-input label="Következő kötelező felülvizsgálat" label-placement="stacked" fill="outline" type="date" [(ngModel)]="szvUrlap.kovetkezo_felulvizsgalat"></ion-input>
                    <ion-input label="Érvényesség (ha nincs felülvizsgálati dátum)" label-placement="stacked" fill="outline" maxlength="255"
                               placeholder="pl. a középfokú tanulmányok befejezéséig" [(ngModel)]="szvUrlap.ervenyesseg"></ion-input>
                    <ion-input label="Megnevezés (fogyatékosság / nehézség)" label-placement="stacked" fill="outline" maxlength="255" [(ngModel)]="szvUrlap.fogyatekossag"></ion-input>
                    <ion-textarea label="A bizottság javaslata (mentesítések, kedvezmények)" label-placement="stacked" fill="outline" [autoGrow]="true" rows="2" [(ngModel)]="szvUrlap.javaslat"></ion-textarea>
                    <ion-textarea label="Megjegyzés" label-placement="stacked" fill="outline" [autoGrow]="true" rows="1" [(ngModel)]="szvUrlap.megjegyzes"></ion-textarea>
                    <div class="of-szv-gombok">
                      <ion-button size="small" (click)="szvMent()" [disabled]="szvMentes">{{ szvMentes ? 'Mentés…' : 'Mentés' }}</ion-button>
                      <ion-button size="small" fill="clear" color="medium" (click)="szvMegse()">Mégse</ion-button>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </ion-card-content>
        </ion-card>
      </ion-col>
    </ion-row>
    <!--  LEMORZSOLÓDÁS – a saját osztály 44/J. § szerinti jelzései és az alkalmazott intézkedések
          (229/2012. Korm. r. 26/A. §; backend/lemorzsolodas.js). Önálló komponens, a kiválasztott osztállyal. -->
    <ion-row *ngIf="nezet === 'lemorzsolodas' && !loadingOsztalyok && osztalyok.length">
      <ion-col size="12">
        <app-lemorzsolodas [mod]="'of'" [osztaly]="kivOsztalyId" [intezmeny]="intezmeny"></app-lemorzsolodas>
      </ion-col>
    </ion-row>
  </ion-grid>

  <!--  EGY TANULÓ IGAZOLÁSAINAK ELŐZMÉNYE – a hiányzás-összesítő kinyitott sorából. -->
  <ion-modal [isOpen]="!!elozmenyTanulo" (didDismiss)="elozmenyTanulo = null" class="of-reszlet-modal">
    <ng-template>
      <app-of-igazolas-elozmeny [intezmeny]="intezmeny" [oktazon]="elozmenyTanulo?.oktazon || ''"
                                [nev]="elozmenyTanulo?.nev || ''" [tanev]="tanev"
                                (bezar)="elozmenyTanulo = null"></app-of-igazolas-elozmeny>
    </ng-template>
  </ion-modal>

  <!--  EGY TANULÓ JEGYEI RÉSZLETESEN – a jegy-táblázatban a névre kattintva. -->
  <ion-modal [isOpen]="!!reszletSor" (didDismiss)="reszletBezar()" class="of-reszlet-modal">
    <ng-template>
      <ion-header>
        <ion-toolbar color="primary">
          <ion-title>{{ reszletSor?.tanulo_nev }}</ion-title>
          <ion-buttons slot="end">
            <ion-button (click)="reszletBezar()" aria-label="Bezárás">
              <ion-icon slot="icon-only" name="close"></ion-icon>
            </ion-button>
          </ion-buttons>
        </ion-toolbar>
      </ion-header>
      <ion-content class="ion-padding">
        <p class="halvany">
          {{ aktivOsztaly?.osztaly_nev }}<span *ngIf="jegyAdat?.tanev"> &middot; {{ jegyAdat.tanev.id }}/{{ jegyAdat.tanev.id + 1 }}. tanév</span>
          &middot; minden tantárgy, minden tanár jegyei
        </p>
        <div *ngIf="!reszletTargyak.length" class="ures">Ebben a tanévben még nincs jegye.</div>

        <div class="tabla-burok" *ngIf="reszletTargyak.length">
          <table class="of-tabla of-reszlet-tabla">
            <thead>
              <tr>
                <th>Tantárgy</th><th>I. félév</th><th>Félévi</th><th class="num">I. átlag</th>
                <th>II. félév</th><th>Év végi</th><th class="num">Éves átlag</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let t of reszletTargyak">
                <td><strong>{{ t.tantargy_nev }}</strong></td>
                <td>
                  <span *ngFor="let j of t.f1" class="of-jegy" [ngClass]="j.sulyOsztaly || ''" [style.color]="j.szinCss"
                        [title]="j.cim" [attr.data-negyedev]="j.jel || null"><small *ngIf="j.jel" class="of-jegy-jel">{{ j.jel }}</small>{{ j.rovid }}</span>
                  <span *ngIf="!t.f1.length" class="halvany">–</span>
                </td>
                <td>
                  <span *ngFor="let j of t.felevi" class="of-jegy of-jegy-zaro" [title]="j.cim">{{ j.rovid }}</span>
                  <span *ngIf="!t.felevi.length" class="halvany">–</span>
                </td>
                <td class="num">{{ t.f1Atlag || '–' }}</td>
                <td>
                  <span *ngFor="let j of t.f2" class="of-jegy" [ngClass]="j.sulyOsztaly || ''" [style.color]="j.szinCss"
                        [title]="j.cim" [attr.data-negyedev]="j.jel || null"><small *ngIf="j.jel" class="of-jegy-jel">{{ j.jel }}</small>{{ j.rovid }}</span>
                  <span *ngIf="!t.f2.length" class="halvany">–</span>
                </td>
                <td>
                  <span *ngFor="let j of t.evvegi" class="of-jegy of-jegy-zaro" [title]="j.cim">{{ j.rovid }}</span>
                  <span *ngIf="!t.evvegi.length" class="halvany">–</span>
                </td>
                <td class="num"><strong [class.of-gyenge]="t.gyenge">{{ t.evesAtlag || '–' }}</strong></td>
              </tr>
            </tbody>
          </table>
        </div>

        <h3 class="of-alcim" *ngIf="reszletIdorend.length">Jegyek időrendben <span class="halvany">– a legfrissebb elöl</span></h3>
        <div class="tabla-burok" *ngIf="reszletIdorend.length">
          <table class="of-tabla">
            <thead>
              <tr><th>Dátum</th><th>Tantárgy</th><th>Jegy</th><th>Típus</th><th>Súly</th><th>Téma</th><th>Tanár</th></tr>
            </thead>
            <tbody>
              <tr *ngFor="let j of reszletIdorend">
                <td class="nowrap">{{ j.datum }}</td>
                <td>{{ j.tantargy_nev }}</td>
                <td>
                  <span class="of-jegy" [ngClass]="j.sulyOsztaly || ''" [class.of-jegy-zaro]="!!j.zaro" [style.color]="j.zaro ? null : j.szinCss" [attr.data-negyedev]="j.jel || null"><small
                        *ngIf="j.jel" class="of-jegy-jel">{{ j.jel }}</small>{{ j.rovid }}</span>
                  <div class="halvany" *ngIf="j.jegy && j.rovid !== j.jegy">{{ j.jegy }}</div>
                </td>
                <td>{{ j.zaro ? (j.zaro === 'F' ? 'Félévi értékelés' : 'Év végi értékelés') : (j.jel ? (j.ertnev || 'Negyedéves értékelés') : (j.emnev || '–')) }}</td>
                <td class="nowrap">{{ j.zaro || j.jel ? '–' : (j.szorzo ?? 100) + '%' }}</td>
                <td>{{ j.tema || '–' }}</td>
                <td>{{ j.tanar_nev || '–' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </ion-content>
    </ng-template>
  </ion-modal>
</ion-content>

<!--  ══════════════════════════════════════════════════════════════════════
      EGY BEKÜLDÖTT IGAZOLÁS ELBÍRÁLÁSA. Három eset fut össze itt:

        - a szülő orvosi / hivatalos igazolást adott be → a nap még NINCS igazolva,
          a papír alapján dől el (elfogadom / elutasítom);
        - a szülő UTÓLAG töltött fel dokumentumot egy már elbírált naphoz → a napot
          nem bántjuk, csak a papírról kell dönteni („rendben, marad", vagy
          átminősítés orvosira – ez adja vissza a napot a szülő keretébe);
        - egy szülői igazolással elfogadott nap átminősítése papír nélkül is.
      ══════════════════════════════════════════════════════════════════════ -->
<ng-template #igDontesSablon let-i="i">
  <div class="ig-dontes" *ngIf="igVanDontes(i)">
    <div class="ig-papir" *ngIf="igPapirElbiralando(i)">
      <ion-icon name="document-attach-outline"></ion-icon>
      A gondviselő utólag töltött fel dokumentumot ehhez a naphoz – nézd meg.
      A nap állapota addig változatlan.
    </div>
    <ion-select interface="popover" fill="outline" label-placement="stacked"
                [label]="igElbiralhato(i) ? 'Elfogadás mint'
                       : (igPapirElbiralando(i) ? 'Átminősítés (nem kötelező)' : 'Átminősítés')"
                [(ngModel)]="igDontesTipus[i.id]"
                [placeholder]="igElbiralhato(i) ? (i.tipus_nev || '')
                             : (igPapirElbiralando(i) ? 'marad, ami volt' : 'válassz típust')">
      <ng-container *ngFor="let t of elbiralasTipusok">
        <ion-select-option *ngIf="igElbiralhato(i) || t.id !== 2" [value]="t.id">{{ t.nev }}</ion-select-option>
      </ng-container>
    </ion-select>
    <ion-input *ngIf="igElbiralhato(i) || igPapirElbiralando(i)" fill="outline"
               label="Indok (elutasításnál kötelező)"
               label-placement="stacked" [(ngModel)]="igDontesIndok[i.id]"
               placeholder="A szülő is látni fogja"></ion-input>
    <div class="ig-dontes-gombok">
      <ion-button size="small" color="success" (click)="igDontes(i, 'jovahagy')"
                  [disabled]="igDontesFolyamatban
                              || (igAtminosithato(i) && !igPapirElbiralando(i) && !igDontesTipus[i.id])">
        <ion-icon slot="start" name="checkmark-outline"></ion-icon>
        {{ igElbiralhato(i) ? 'Elfogadom'
          : (igPapirElbiralando(i) ? (igDontesTipus[i.id] ? 'Elfogadom és átminősítem' : 'Rendben, marad')
          : 'Átminősítem') }}
      </ion-button>
      <ion-button *ngIf="igElbiralhato(i) || igPapirElbiralando(i)" size="small" color="danger" fill="outline"
                  (click)="igDontes(i, 'elutasit')" [disabled]="igDontesFolyamatban">
        <ion-icon slot="start" name="close-outline"></ion-icon>
        {{ igElbiralhato(i) ? 'Elutasítom' : 'A papírt nem fogadom el' }}
      </ion-button>
    </div>
  </div>
</ng-template>
